const isTypeValid = (data) => {
    if (data.type === 'messageBus' && data.messageBusTopic && data.messageBusValue) {
        return true;
    }
    if (data.type === 'url' && data.url) {
        return true;
    }
    return false;
};
const isDataValid = (data) => {
    if (data.ctaText && data.headerTitle && data.imageUrl) {
        if (isTypeValid(data))
            return true;
    }
    return false;
};
export const mapWidgetData = (data) => {
    if (!isDataValid(data)) {
        return null;
    }
    return {
        ctaText: data.ctaText,
        imageUrl: data.imageUrl,
        content: {
            headerTitle: data.headerTitle,
            text: data.text,
        },
        navigation: {
            type: data.type,
            url: data.url,
            messageBusTopic: data.messageBusTopic,
            messageBusValue: data.messageBusValue,
        },
    };
};
